<template lang="pug">
  b-container
    .d-flex.justify-content-between.mb-2
      h4.mb-0 Plantillas
      b-button.b-0(variant="link", size="sn", @click="saveMixpanel('Whatsapp Templates: Redirect to Campaigns')", :to="{name : 'Campaigns'}")
        chevron-left-icon.icon-md
        span Volver a campañas
    // BUTTONS ROW
    b-row.justify-content-between.mb-3
      // WATHSAPP SELECTION
      b-col.mb-2.mb-md-0.d-flex.align-items-center(sm="12", md="6", lg="6")
        b-img.mr-1(src="@/assets/chatbot.png", width="40" )
        div(v-if="singleWhatsapp")
          div {{whatsappName}}
          .text-secondary.text-sm Total de plantillas {{templatesMetrics.total}}
        b-dropdown(v-else, variant="white", :disabled="loading" block, no-caret, :menu-class="['text-truncate', 'scroll-dropdown', 'scrollable-area', 'overflow-y']")
          template(#button-content)
            .d-flex.justify-content-between
              .text-left
                div {{whatsappName}}
                .text-secondary.text-sm Total de plantillas {{templatesMetrics.total}}
              b-spinner(small, variant="primary", v-if="loading" )
              chevron-down-icon(v-else)
          b-dropdown-item(v-for="wa in whatsapp_accounts", :key="wa.model_id", @click="wabaId = wa.waba_id")
            span.mr-1 {{wa.name}}
            span.text-secondary - {{wa.phone_number}}
      // CREATE BUTTONS
      b-col.text-left(sm="12", md="auto")
        b-button.pl-2.bl-1(variant="an", :to="{name : 'New Whatsapp Template', params: { wabaId }}")
          .d-flex.align-items-center
            plus-icon.icon-sm.mr-1
            span Crear plantilla
    b-card
      // CARD TABS
      b-tabs(small, lazy)
        // CREATED TEMPLATES TAB
        b-tab.mt-3(title="Plantillas creadas" )
          // TOP TABLE
          b-form-row.align-items-center.my-3.justify-content-between
            // METRICS DATA
            b-col.mb-2.mb-md-0(md="6")
              b-form-row.justify-content-evenly.text-center
                b-col(cols="4")
                  span.mr-1 {{templatesMetrics.approved}}
                  small Aprobadas
                b-col.bx-1.border-dark(cols="4")
                  span.mr-1 {{templatesMetrics.rejected}}
                  small Rechazadas
                b-col(cols="4")
                  span.mr-1 {{templatesMetrics.pending}}
                  small Pendientes
            // SEARCH && DOWNLOAD
            b-col(md="6", lg="5")
              b-form-row.align-items-center
                // SEARCH INPUT
                b-col
                  b-input-group#search-input
                    b-form-input(placeholder="Buscar plantilla", v-model="search", debounce="1000" type="search", @update="getMessageTemplates")
                    b-input-group-append
                      b-input-group-text
                        search-icon.icon-md
                // FILTER BUTTON
                b-col(cols="auto")
                  b-dropdown(size="sm", variant="primary", no-caret, right, v-b-tooltip, title="Filtrar")
                    template(#button-content)
                      filter-icon.icon-md
                    b-dd-header Filtrar por categoría
                    b-dropdown-form
                      b-form-checkbox-group(v-model="categoriesFilter", size="sm", stacked, :options="categoriesOptions", @change="getMessageTemplates")
                // DOWNLOAD BUTTON
                b-col(cols="auto" )
                  b-button(size="sm", variant="primary", v-b-tooltip, title="Descargar plantillas", :disabled="downloading", @click="downloadTemplates")
                    b-spinner(small, v-if="downloading" )
                    download-icon.icon-md(v-else)
          // TEMPLATES HEADERS
          b-form-row.mb-3.px-2.d-none.d-md-flex.mt-3
            b-col(md="2", v-for="field in fields", :key="field") {{field}}
          // LOADING
          .text-center(v-if="loadingTemplates")
            b-spinner.mt-3(variant="primary" )
          empty-message(v-else-if="!message_templates.length", :message="search.length ? 'No hay coincidencias' : 'No hay plantillas creadas'" )
          // TEMPLATES LIST
          b-card.mb-1(v-for="(item, index) in message_templates", :key="index", body-class="p-2" )
            b-form-row.align-items-center.text-center.text-md-left.text-sm
              b-col(md="2" )
                WhatsappTemplatePreview(v-bind="item", :prev-id="item.id")
              b-col(md="2" ) {{item.name}}
              b-col(md="2" )
                b-badge(pill, :variant="item.status === 'Aprobado' ? 'soft-success' : (item.status === 'Rechazado' ?  'soft-danger' : 'soft-warning') ") {{item.status}}
              b-col(md="2" ) {{item.category_name}}
              b-col(md="2" ) {{item.language_name}}
              b-col(md="2" )
                b-overlay(:show="item.loading", variant="transparent", spinner-variant="primary", spinner-small)
                  b-form-group(label="Cuenta:", label-size="sm")
                    k-select(:options="accounts", placeholder="Selecciona cuenta", v-model="item.account_id", @input="updateAccountId(item)")
                  block-connector(:next_block_id="item.block_id", pill, button-only, clearable, @change="updateTemplateBlockId(item, $event)")
                  trash-icon.pointer.hover-danger.icon-md.ml-2(@click.stop="confirmDelete(item).then()", v-b-tooltip, title="Eliminar")
          // PAGINATION SECTION
          .pagination-row
            b-button.mr-1(size="sm", variant="link", :disabled="loadingTemplates || !hasPrevious", @click="getMessageTemplates('before')")
              chevron-left-icon
            b-button.ml-1(size="sm", variant="link", :disabled="loadingTemplates || !hasNext", @click="getMessageTemplates('after')")
              chevron-right-icon
        // PROGRAMED TEMPLATES TAB
        b-tab.mt-3(title="Envíos programados" )
          BroadcastScheduled
</template>

<script>
import BroadcastScheduled from "@/views/account/CampaignsScheduled";
import WhatsappTemplatePreview from "@/components/WhatsappTemplatePreview";
import Select from '@/components/Select'
import { createNamespacedHelpers, mapActions } from "vuex";
import Download from "downloadjs";
import mixpanel from "@/mixpanel";

const organizationController = createNamespacedHelpers('organization')
const accountController = createNamespacedHelpers('account')
const templatesController = createNamespacedHelpers('message_template')

export default {
  name: "WhatsappTemplates",
  data () {
    return {
      loading: false,
      loadingTemplates: false,
      downloading: false,
      hasNext: false,
      hasPrevious: false,
      wabaId: null,
      before: null,
      after: null,
      limit: 500,
      deleteTemplateCounter: 0,
      search: '',
      categoriesFilter: [],
      categoriesOptions: [
        { value: "TRANSACTIONAL", text: "Utilidad"},
        { value: "MARKETING", text: "Marketing"},
        { value: "OTP", text: "Autenticación"}
      ],
      fields: [
        'Vista previa',
        'Nombre',
        'Estatus',
        'Categoría',
        'Idioma',
        'Acciones'
      ],
      templatesMetrics: {
        total: 0,
        approved: 0,
        rejected: 0,
        pending: 0
      },
    }
  },
  computed: {
    ...templatesController.mapState({
      whatsapp_accounts: state => state.whatsapp_accounts,
      message_templates: state => state.message_templates
    }),
    ...accountController.mapState({
      account: state => state.account
    }),
    ...organizationController.mapState({
      accounts: state => state.accounts.map(el => {
        return {
          id: el.account_id,
          label: el.name
        }
      })
    }),
    singleWhatsapp () {
      return this.whatsapp_accounts.length === 1
    },
    whatsappName () {
      if(!this.wabaId) return ''
      const whatsappAccount = this.whatsapp_accounts.find(el => el.waba_id === this.wabaId)
      if(!whatsappAccount) return ''
      const {name, phone_number} = whatsappAccount
      return `${name} ${phone_number}`
    },
  },
  methods: {
    ...mapActions([
      'organization/accounts',
      'message_template/whatsapps',
      'message_template/all',
      'message_template/update',
      'message_template/updateTemplate',
      'message_template/destroy',
      'message_template/templates_metrics',
      'message_template/download_templates',
    ]),
    getOrganizationAccounts () {
      this.loading = true
      this['organization/accounts']({
        organization_id: this.account.organization_id,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    getWhatsAppAccounts () {
      this.loading = true

      this['message_template/whatsapps']({
        account_id: this.$route.params.account_id,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)

          if(res.resource.length) {
            const {waba_id} = res.resource[0]
            this.wabaId = waba_id
          }
        }
      })
    },
    getMessageTemplates (page) {
      this.loadingTemplates = true

      const params = {
        limit: this.limit,
        name: this.search,
        all: true,
        account_id: this.$route.params.account_id,
        categories: this.categoriesFilter.join(",")
      }
      if (page) params[page] = this[page]

      this['message_template/all']({
        waba_id: this.wabaId,
        params,
        callback: res => {
          this.loadingTemplates = false
          if (res.error) return this.$message.error(res.error)

          this.hasNext = res.has_next || false
          this.hasPrevious = res.has_previous || false
          this.before = res.before
          this.after = res.after
          this.getTemplatesMetrics()

          if (params.categories.length) {
            this.saveMixpanel(`Whatsapp Templates: Filter templates`, {categories: params.categories})
          }
        }
      })
    },
    getTemplatesMetrics () {
      this['message_template/templates_metrics']({
        waba_id: this.wabaId,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
          this.templatesMetrics = Object.assign({}, res.data)
        }
      });
    },
    updateTemplateBlockId (item, {next_block_id}) {
      item.loading = true
      item.block_id = next_block_id
      this['message_template/update']({
        id: item.id,
        block_id: next_block_id,
        callback: res => {
          item.loading = false
          if (res.error) this.$message.error(res.error)
          this.$message.success('Bloque actualizado')
        }
      });
    },
    updateAccountId(item) {
      item.loading = true
      this['message_template/updateTemplate']({
        accountId: item.account_id,
        name: item.name,
        params: {
          wabaId: this.wabaId,
        },
        callback: res => {
          item.loading = false

          if (res.error) this.$message.error(res.error)

          this.$message.success('Cuenta actualizada')
        }
      })
    },
    async confirmDelete (item) {
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Eliminar plantilla ${item.name}?`, {
          title: 'Eliminar plantilla',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
        })
        if (response) {
          this.deleteTemplate(item)
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    deleteTemplate (item) {
      item.loading = true
      this['message_template/destroy']({
        waba_id: this.wabaId,
        ...item,
        callback: res => {
          item.loading = false
          if (res.error) return this.$message.error(res.error)

          this.$message.success('Plantilla eliminada')
          this.removeTemplateFromList(item)
          this.getTemplatesMetrics()
        }
      })
    },
    removeTemplateFromList (item) {
      this.deleteTemplateCounter++
      this.message_templates = this.message_templates.filter(t => t.id !== item.id)
      if(this.deleteTemplateCounter >= this.limit){
        this.deleteTemplateCounter = 0
        const page = this.hasNext ? 'after' : 'before'
        this.getMessageTemplates(page)
      }
    },
    async downloadTemplates (){
      try {
        this.downloading = true
        this['message_template/download_templates']({
          waba_id: this.wabaId,
          callback: res => {
            this.downloading = false
            if (res.error) return this.$message.error(res.error)

            Download(res.data, `Plantillas(${this.whatsappName}).csv`, res.headers['content-type'])
            this.saveMixpanel(`Whatsapp Templates: Download templates`)
          }
        })
      } catch (e) {
        console.error(e.toString())
      }
    },
    saveMixpanel (event, data = {}) {
      const {email, admin_id, role_id} = this.getCurrentUser()
      mixpanel.track(event, {
        account_id: this.$route.params.account_id,
        unique_id: email,
        admin_id,
        role_id,
        ...data
      });
    }
  },
  mounted () {
    this.getWhatsAppAccounts()
  },
  watch: {
    wabaId () {
      this.getMessageTemplates()
    },
    account (val, old) {
      if(val !== old) this.getOrganizationAccounts()
    }
  },
  components: {BroadcastScheduled, WhatsappTemplatePreview, 'k-select': Select }
}
</script>

<style lang="scss" scoped>

.custom-checkbox:hover {
  background-color: #a5aff5;
}

.template-preview {
  width: 12rem;
}

.pagination-row {
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>